if (!customElements.get('bl-product-page')) {
  customElements.define('bl-product-page', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.words = JSON.parse(this.querySelector('[data-product-words]').textContent);
      this.quantity = this.querySelector('[name="quantity"]');
      this.mainImage = this.querySelector('.blp-main-image');
      this.initialImage = this.mainImage?.src;
      this.button = this.querySelector('.blp-add');
      this.mobileButton = this.querySelector('[data-mobile-add]');
      this.formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
      this.addEventListener('change', event => {
        if (event.target.matches('.blp-format input')) this.updateFormat(event.target, true);
        if (event.target === this.quantity) this.updateTotal();
      });
      this.addEventListener('input', event => { if (event.target === this.quantity) this.updateTotal(); });
      this.addEventListener('click', event => {
        const stepper = event.target.closest('[data-quantity-step]');
        if (stepper) {
          const value = Number(this.quantity.value) || Number(this.quantity.min) || 1;
          const step = Number(this.quantity.step) || 1;
          this.quantity.value = Math.max(Number(this.quantity.min) || 1, Math.min(Number(this.quantity.max) || Infinity, value + Number(stepper.dataset.quantityStep) * step));
          this.updateTotal();
        }
        if (event.target.closest('[data-mobile-add]')) {
          const form = this.querySelector('product-form form');
          if (form.reportValidity()) form.requestSubmit(this.button);
        }
        const photo = event.target.closest('[data-photo]');
        if (photo && this.mainImage) {
          this.clearCopies();
          this.mainImage.src = photo.dataset.photo;
          this.mainImage.removeAttribute('srcset');
          this.querySelectorAll('[data-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === photo)));
        }
      });
      this.buttonObserver = new MutationObserver(() => {
        const busy = this.button.getAttribute('aria-disabled') === 'true';
        this.mobileButton.disabled = this.button.disabled || busy;
        this.mobileButton.setAttribute('aria-busy', String(busy));
      });
      this.buttonObserver.observe(this.button, { attributes: true, attributeFilter: ['aria-disabled', 'disabled'] });
      const selected = this.querySelector('.blp-format input:checked');
      if (selected) this.updateFormat(selected, false);
      else {
        this.price = Number(this.querySelector('[data-main-price]').dataset.cents);
        this.updateTotal();
      }
      window.addEventListener('popstate', this.onHistory = () => {
        const id = new URL(location.href).searchParams.get('variant');
        const choice = [...this.querySelectorAll('.blp-format input')].find(input => input.value === id) || this.querySelector('.blp-format input');
        if (choice) { choice.checked = true; this.updateFormat(choice, false); }
      });
    }
    disconnectedCallback() {
      this.buttonObserver?.disconnect();
      window.removeEventListener('popstate', this.onHistory);
    }
    money(cents) { return this.formatter.format(cents / 100); }
    clearCopies() {
      this.querySelectorAll('[data-pack-copy]').forEach(copy => copy.remove());
      this.querySelector('[data-gallery-stage]').classList.remove('blp-photo-multi');
    }
    updateFormat(choice, updateUrl) {
      this.price = Number(choice.dataset.price);
      const count = Number(choice.dataset.count) || 1;
      const counted = this.dataset.counted === 'true';
      const available = choice.dataset.available === 'true';
      const title = choice.dataset.title;
      this.querySelector('input[name="id"]').value = choice.value;
      this.querySelector('[data-main-price]').textContent = choice.dataset.money;
      this.querySelector('[data-fact-price]').textContent = choice.dataset.money;
      this.querySelector('[data-per-unit]').textContent = counted && count > 1 ? ' · ' + this.words.unit.replace('[price]', this.money(this.price / count)) : '';
      const saving = Number(this.dataset.unitPrice) * count - this.price;
      const savings = this.querySelector('[data-saving]');
      savings.hidden = !(counted && count > 1 && saving > 0);
      savings.textContent = this.words.saving.replace('[price]', this.money(saving)).replace('[count]', count);
      this.querySelector('[data-quantity-label]').textContent = counted && count > 1 ? this.words.lots : this.words.quantity;
      this.querySelector('[data-format-help]').textContent = counted && count > 1 ? this.words.lotHelp.replace('[count]', count) : this.words.help;
      this.querySelector('[data-gallery-label]').textContent = title;
      this.querySelector('[data-fact-format]').textContent = title;
      this.querySelector('[data-mobile-format]').textContent = title;
      this.querySelector('[data-add-label]').textContent = available ? this.button.dataset.addText : this.button.dataset.soldText;
      this.querySelector('[data-mobile-add-label]').textContent = available ? this.button.dataset.addText : this.button.dataset.soldText;
      this.button.disabled = !available;
      this.button.removeAttribute('aria-disabled');
      this.mobileButton.disabled = !available;
      this.quantity.min = choice.dataset.min || '1';
      this.quantity.step = choice.dataset.step || '1';
      if (choice.dataset.max) this.quantity.max = choice.dataset.max;
      else this.quantity.removeAttribute('max');
      this.quantity.value = this.quantity.min;
      this.querySelector('.product-form__error-message-wrapper').hidden = true;
      if (this.mainImage) {
        this.clearCopies();
        this.mainImage.src = choice.dataset.image || this.initialImage;
        this.mainImage.removeAttribute('srcset');
        if (counted && count > 1 && count <= 6) {
          this.querySelector('[data-gallery-stage]').classList.add('blp-photo-multi');
          for (let i = 1; i < count; i++) {
            const copy = this.mainImage.cloneNode();
            copy.dataset.packCopy = 'true';
            copy.alt = '';
            copy.setAttribute('aria-hidden', 'true');
            copy.removeAttribute('fetchpriority');
            this.querySelector('[data-gallery-stage]').insertBefore(copy, this.querySelector('[data-gallery-label]'));
          }
        }
      }
      this.updateTotal();
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', choice.value);
        history.replaceState({}, '', url);
      }
    }
    updateTotal() {
      if (!Number.isFinite(this.price)) return;
      const quantity = Number(this.quantity.value) || Number(this.quantity.min) || 1;
      const total = this.money(this.price * quantity);
      this.querySelector('[data-add-total]').textContent = '— ' + total;
      this.querySelector('[data-mobile-total]').textContent = total;
      this.querySelectorAll('[data-quantity-step]').forEach(button => {
        button.disabled = Number(button.dataset.quantityStep) < 0 ? quantity <= Number(this.quantity.min) : Boolean(this.quantity.max) && quantity >= Number(this.quantity.max);
      });
    }
  });
}
if (!customElements.get('bl-collection-page')) {
  customElements.define('bl-collection-page', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const form = this.querySelector('.blc-filter-form');
      const dialog = this.querySelector('dialog');
      const media = matchMedia('(max-width: 989px)');
      const move = () => {
        if (!media.matches && dialog.open) dialog.close();
        this.querySelector(media.matches ? '[data-filter-dialog-home]' : '[data-filter-home]').append(form);
      };
      move();
      media.addEventListener('change', this.onResize = move);
      this.media = media;
      this.querySelector('[data-open-filters]').addEventListener('click', () => dialog.showModal());
      this.querySelector('[data-close-filters]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      this.querySelector('select[name="sort_by"]').addEventListener('change', () => form.requestSubmit());
      form.addEventListener('change', event => {
        if (!media.matches && event.target.type === 'checkbox') form.requestSubmit();
      });
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[type="number"]').forEach(input => { input.disabled = input.value === ''; });
      });
    }
    disconnectedCallback() { this.media?.removeEventListener('change', this.onResize); }
  });
}
